import React from 'react';

const Loading = () => (
  <div>
    <main role="main" id="container" className="main-container push">
      <section>
        <div className="content">
          <div className="loading">
            <div className="loading-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="184 -40 106 160" width="200" height="150">
              <path 
              fill="currentColor" 
              d="M221.63,23.62,209.69,36.5l-7.59-7.4V82.58H153.62V29.1l-7.4,7.77L133.64,24.1,154.57,0H167.9c0,.21,0,.43,0,.65a9.76,9.76,0,0,0,19.51,0c0-.22,0-.44,0-.65h13Z"/>

              </svg>
            </div>
            <p className="loading-text">Loading</p>
          </div>
        </div>
      </section>
    </main>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/global/Loading.js